import { useState } from "react";
import PopupPagination from "../../../../component/Pagination/popupPagination";
import { TournamentTicketResponseForSeller } from "../../../../api/tournament-ticket";
import * as S from "./styles";

interface TableProps {
  list: TournamentTicketResponseForSeller[];
  searchQuery: string;
  totalPages: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  handleSearchQueryChange: (query: string) => void;
  onBuy: (ticket: TournamentTicketResponseForSeller) => void;
}

const COLUMNS = [
  { header: "티켓명", className: "name" },
  { header: "보유 수량", className: "count" },
  { header: "보유가능수량", className: "limit" },
  { header: "교환수량/상한", className: "buyLimit" },
  { header: "교환 캐럿", className: "price" },
  { header: "유저 교환 캐럿", className: "userPrice" },
  { header: "", className: "action" },
];

const formatCr = (value: number | null | undefined) =>
  value == null ? "-" : `${value.toLocaleString()}CR`;

const formatCount = (value: number | null | undefined) =>
  value == null ? "-" : `${value.toLocaleString()}장`;

const formatBuyLimit = (item: TournamentTicketResponseForSeller) => {
  const bought = (item.buyCount ?? 0).toLocaleString();
  if (item.buyLimitCount == null) return `${bought}/무제한`;
  return `${bought}/${item.buyLimitCount.toLocaleString()}`;
};

const Table = ({
  list,
  searchQuery,
  totalPages,
  currentPage,
  setCurrentPage,
  handleSearchQueryChange,
  onBuy,
}: TableProps) => {
  const [searchInput, setSearchInput] = useState(searchQuery);

  const onSearch = () => {
    handleSearchQueryChange(searchInput.trim());
  };

  return (
    <S.TableWrapper>
      <S.TableTitleHeader>
        <div className="title">티켓 목록</div>
        <S.FilterWrapper>
          <S.SearchBox>
            <input
              type="text"
              placeholder="티켓명을 검색하세요."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyUp={(e) => {
                if (e.key === "Enter") onSearch();
              }}
            />
            <div className="searchIcon" onClick={onSearch}>
              <img
                src="/image-web/timer-config/searchIcon.svg"
                alt="검색 아이콘"
              />
            </div>
          </S.SearchBox>
        </S.FilterWrapper>
      </S.TableTitleHeader>
      <S.HeaderLine />

      <S.TableContent>
        <S.TableHeader>
          {COLUMNS.map((column) => (
            <div key={column.className} className={`item ${column.className}`}>
              {column.header}
            </div>
          ))}
        </S.TableHeader>

        <S.ListWrapper>
          {list.length === 0 ? (
            <S.EmptyMessage>티켓이 존재하지 않습니다.</S.EmptyMessage>
          ) : (
            list.map((item) => (
              <S.TableItem key={item.id}>
                <div className="item name">{item.name}</div>
                <div className="item count">{formatCount(item.hasCount)}</div>
                <div className="item limit">
                  {formatCount(item.sellerLimitCount)}
                </div>
                <div className="item buyLimit">{formatBuyLimit(item)}</div>
                <div className="item price">{formatCr(item.sellerPrice)}</div>
                <div className="item userPrice">{formatCr(item.userPrice)}</div>
                <div className="item action">
                  <div className="buy" onClick={() => onBuy(item)}>
                    교환
                  </div>
                </div>
              </S.TableItem>
            ))
          )}
        </S.ListWrapper>
      </S.TableContent>

      {totalPages > 1 && (
        <S.PaginationBox>
          <PopupPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </S.PaginationBox>
      )}
    </S.TableWrapper>
  );
};

export default Table;
